import * as z from 'zod';

import { GSEName } from '../loan/Loan';
import { DateFilter } from '../loanTransactionFilter/LoanTransactionFilter';
import { InvestorReportingReportType } from './InvestorReporting';

export const InvestorReportingInvestorNameFilter = z.object({
  type: z.literal('enum'),
  key: z.literal('investor'),
  filter: z.object({
    values: z.array(GSEName),
  }),
});
export type InvestorReportingInvestorNameFilter = z.infer<typeof InvestorReportingInvestorNameFilter>;

export const InvestorReportingTypeFilter = z.object({
  type: z.literal('enum'),
  key: z.literal('reportType'),
  filter: z.object({
    values: z.array(InvestorReportingReportType),
  }),
});
export type InvestorReportingTypeFilter = z.infer<typeof InvestorReportingTypeFilter>;

const InvestorReportingCreatedAtFilter = z.object({
  type: z.literal('date'),
  key: z.literal('createdAt'),
  filter: DateFilter,
});
type InvestorReportingCreatedAtFilter = z.infer<typeof InvestorReportingCreatedAtFilter>;

export const InvestorReportingFilter = z.discriminatedUnion('key', [
  InvestorReportingInvestorNameFilter,
  InvestorReportingTypeFilter,
  InvestorReportingCreatedAtFilter,
]);
export type InvestorReportingFilter = z.infer<typeof InvestorReportingFilter>;
